var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({attrs:{"placeholder":_vm.phtext}},'v-text-field',_vm.computedProps,false),_vm.computedListeners))}
var staticRenderFns = []

export { render, staticRenderFns }